/**
 * Small, reusable contextual "Help & Guide" icon button — deep-links to
 * `/help?section=<section>` (see `pages/help/helpContent.ts` for valid
 * section ids). Used on high-priority pages (Broker Account, Algo
 * Strategies, Option Analyst) so a user can jump straight to the relevant
 * guide section without hunting for it in the top navigation bar.
 */
import { Link as RouterLink } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export function HelpGuideLink({ section }: { section: string }) {
  return (
    <Tooltip title="Help & Guide">
      <IconButton
        component={RouterLink}
        to={`/help?section=${section}`}
        size="small"
        aria-label="Open Help & Guide for this page"
      >
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export default HelpGuideLink;
